import { ACCOUNT_TYPES } from "../app/appConstants";

const parseAccountName = (str) => {
    if (!str) {
        return null;
    }
    const accountCode = str.replace(/^default:/, '');
    const type = Object.values(ACCOUNT_TYPES).find(type => {
        return accountCode.indexOf(type) === 0;
    });
    if (!type) {
        return null;
    }
    const replace = `^${type}([^a-zA-Z0-9])`;
    const re = new RegExp(replace, 'g');
    const email = accountCode.replace(re, '');
    return {
        accountCodeFull: `default:${accountCode}`,
        accountCode: accountCode,
        type: type.toLowerCase(),
        email: email,
        getAccountCode: (withType = type) => {
            return `${withType}#${email}`;
        }
    }
};

export default parseAccountName;
